import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { HttpTranslateFactory } from 'src/app/helpers';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CustomPipesModule } from 'src/app/pipes/custom-pipes.module';
import { DashboardService } from 'src/app/services/dashboard.service';
import { NgChartsModule } from 'ng2-charts';
import { CommonChartComponent } from '../common-chart/common-chart.component';
import { DashboardCardComponent } from '../dashboard-card/dashboard-card.component';

@NgModule({
  declarations: [DashboardCardComponent, CommonChartComponent],
  imports: [
    CommonModule,
    CustomPipesModule,
    TranslateModule.forChild({
      loader: {
        deps: [HttpClient],
        provide: TranslateLoader,
        useFactory: HttpTranslateFactory,
      },
    }),
  ],
  providers: [DashboardService],
  exports: [DashboardCardComponent, CommonChartComponent],
})
export class DashboardModule {} // todo it's a shared module
